module.exports = __webpack_public_path__ + "img/react.b7b6c216.png";